import * as THREE from 'three';

const ROWS = 6;
const COLUMNS = 8;
const ROW_OFFSET = 0.3;
const COLUMN_OFFSET = 0.31;

export function createKollektorGrid(root) {
   const kollektor = root.getObjectByName('Kollektor');
   if (!kollektor?.isMesh) {
      console.warn('[Kollektor] Kollektor mesh not found.');
      return null;
   }

   const instances = new THREE.InstancedMesh(
      kollektor.geometry,
      kollektor.material,
      ROWS * COLUMNS,
   );
   instances.name = 'KollektorInstances';
   instances.castShadow = kollektor.castShadow;
   instances.receiveShadow = kollektor.receiveShadow;
   instances.frustumCulled = false;
   kollektor.parent.add(instances);
   kollektor.visible = false;

   const matrix = new THREE.Object3D();

   let instanceIndex = 0;

   for (let row = 0; row < ROWS; row += 1) {
      for (let column = 0; column < COLUMNS; column += 1) {
         matrix.position.copy(kollektor.position);
         matrix.position.x += (column + 1) * COLUMN_OFFSET;
         matrix.position.z += row * ROW_OFFSET;
         matrix.rotation.copy(kollektor.rotation);
         matrix.scale.copy(kollektor.scale);
         matrix.updateMatrix();
         instances.setMatrixAt(instanceIndex, matrix.matrix);
         instanceIndex += 1;
      }
   }

   instances.count = instanceIndex;
   instances.instanceMatrix.needsUpdate = true;

   return {
      destroy() {
         kollektor.parent.remove(instances);
      },
   };
}
